import { WEB_APP_URL } from '@/constants';

export const createWebAppAuthTokenUrl = (token: string) =>
  `${WEB_APP_URL}/auth/${token}`;
